import Section, { SubSection } from './Section'
import styled from 'styled-components'
import { t, tStr } from '@utils/lang'

const CitiesSection = styled(Section)`
  background: var(--themeColorBetaBgBrown);
`
const StyledList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  padding: 0;
  margin: 0;
  list-style: none;
  justify-content: space-between;
  a {
    text-decoration: underline;
  }
  li {
    width: 25%;
    text-align: left;
    font-family: var(--themeFontFamilyHeader);
    color: var(--themeColorBetaBrandHeader);
    font-size: var(--themeFontSizeH4);
    text-transform: uppercase;
    font-weight: var(--themeFontWeightLight);
  }
`
const ListOfCities = () => (
  <StyledList>
    <li>Austin</li>
    <li>Beaumont</li>
    <li>College Station</li>
    <li>Corpus Christi</li>
    <li>Dallas</li>
    <li>Ft.&nbsp;Worth</li>
    <li>Houston</li>
    <li>Killeen</li>
    <li>Lubbock</li>
    <li>Midland</li>
    <li>Odessa</li>
    <li>San&nbsp;Antonio</li>
    <li>Temple</li>
    <li>Waco</li>
    <li>
      <a href="https://www.favordelivery.com/faq" target="_blank" rel="noreferrer">
        {t('citiesMore_s')}
      </a>
    </li>
  </StyledList>
)

const Cities = () => (
  <CitiesSection>
    <SubSection title={tStr('citiesTitle_s')} img={<ListOfCities />} flipSides>
      {t('citiesBody_s')}
    </SubSection>
  </CitiesSection>
)

export default Cities
